import { CLEAR_PROFILE, FETCH_PROFILE, SET_PROFILE } from "../actions";

const initialState = {
    profileData: null,
    isLoading: false,
    error: null,
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROFILE:
            return { ...state, isLoading: true, error: null };

        case SET_PROFILE:
            return { ...state, profileData: action.payload, isLoading: false, error: null };

        case CLEAR_PROFILE:
            return { ...state, profileData: null, isLoading: false, error: null };

        default:
            return state;
    }
};

export default profileReducer;
